const Top = 'Top'
const TopWithText = 'TopWithText'
const Gallery = 'Gallery'
const GalleryInline = 'GalleryInline'

export const type = { Top, Gallery, GalleryInline, TopWithText }
